import { render, staticRenderFns } from "./FeaturedCategory.vue?vue&type=template&id=26be842e&"
import script from "./FeaturedCategory.vue?vue&type=script&lang=js&"
export * from "./FeaturedCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports